import { useState } from 'react';
import { FcGoogle } from 'react-icons/fc';

import useScreenSize from '@/hooks/useScreenSize';
import useStateHandler from '@/hooks/useStateHandler';
import { signInWithGoogle } from '@/services/firebase.service';
import { exchangeGoogleUserForSession } from '@/services/google-auto-flow.service';
import Loader from '@/shared-components/loader/Loader';
import Text from '@/shared-components/text/components/Text';

import './styles/GoogleButton.css';

export default function GoogleButton({ close, className = '', textButton='Continue with Google' }) {
  const { stateHandler, state } = useStateHandler();
  const [loading, setLoading] = useState(false);
  const screenSize = useScreenSize();

  const googleHandler = async () => {
    setLoading(true);
        
    console.info("[GoogleButton] CLICK Google, starting signInWithGoogle");
    const firebaseResponse = await signInWithGoogle();
    console.info("[GoogleButton] signInWithGoogle response", firebaseResponse);

    if (firebaseResponse.code === "auth/redirect-in-progress") {
      console.info("[GoogleButton] Google redirect in progress", firebaseResponse);
      setLoading(false);
      return;
    }

    if (firebaseResponse.code) {
      console.info("[GoogleButton] Firebase returned code, stopping flow", firebaseResponse.code);
      console.error("[GoogleButton] Google sign-in failed", firebaseResponse);
      alert("We couldn’t start Google sign-in. Please try again later.");
      setLoading(false);
      return;
    }

    const loginResult = await exchangeGoogleUserForSession({
      firebaseUser: firebaseResponse.user,
      inviteCode: state.invite,
      stateHandler,
      setLoading,
    });

    if (!loginResult.ok) {
      if (loginResult.reason === "email-belongs-to-artist") {
        alert("This email is already associated with an artist");
      } else {
        alert("We could not complete your sign in. Please try again.");
      }
      setLoading(false);
      return;
    }

    if (typeof close === "function") {
      const isNewUser = Boolean(loginResult.data?.meta?.isNewUser);
      close(isNewUser ? "signup_success_google" : "login_success_google");
    }
  };

  return (
    <>
      <button className={`${className} ${loading ? "disabled" : ""}`} onClick={googleHandler}> 
        <FcGoogle className="google-icon "/>
        <span className="unregistered-google__container-text">
          <Text className="unregistered-google__text">{(screenSize.width <= 431 && loading) ? "" : textButton} {loading && <Loader inline className="unregistered-google__spinner" thin />}</Text>
          
        </span>
      </button>
    </>
  );
}
